import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss+reset_kbwqvznrvxnnvxa5u7auhj6mca/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth from "/vercel/path0/node_modules/.pnpm/@fixers+nuxt-authjs@0.0.20_nodemailer@6.9.13_rollup@4.18.0/node_modules/@fixers/nuxt-authjs/dist/runtime/middleware/auth.mjs";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.8.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss+reset_kbwqvznrvxnnvxa5u7auhj6mca/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth,
  manifest_45route_45rule
]
export const namedMiddleware = {}